import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { InfoAnagrafichePFDTO } from '../../../models/info-anagrafiche-pf';
import { ComponentOutputStatus } from '../../../normalizzazione/component-output-status';
import { MessageService } from '../../../services/message.service';
import { ValidationService } from '../../../services/validation.service';

@Component({
	selector: 'lib-pf',
	templateUrl: './pf.component.html',
	styleUrls: ['./pf.component.css']
})
export class PfComponent implements OnInit, OnDestroy {

	@Input()
	resetForm: Subject<boolean>;

	@Output()
	done: EventEmitter<
		ComponentOutputStatus<InfoAnagrafichePFDTO>
	> = new EventEmitter<ComponentOutputStatus<InfoAnagrafichePFDTO>>();

	form: FormGroup;

	subscription: Subscription;

	constructor(private msg: MessageService) { }

	ngOnInit(): void {

		this.form = new FormGroup({});

		if (this.resetForm) {
			this.subscription = this.resetForm.subscribe(val =>
				val ? this.pulisciForm() : "");
		}

		const codiceFiscale = new FormControl(
			{ value: '', disabled: false },
			[
				ValidationService.pattern(
					ValidationService.codiceFiscale,
					"cfInvalidoFormalmente"
				),
			]
		);

		this.form.addControl("codiceFiscale", codiceFiscale);

		const nome = new FormControl({ value: '', disabled: false },
			[
				ValidationService.pattern(ValidationService.formatoName, "formatoName")
			]);
		this.form.addControl("nome", nome);

		const cognome = new FormControl(
			{ value: '', disabled: false },
			[
				ValidationService.pattern(ValidationService.formatoName, "formatoName")
			]);
		this.form.addControl("cognome", cognome);

		const changes$ = this.form.valueChanges.pipe(
			map((_) => {
				const pf = new InfoAnagrafichePFDTO();
				pf.codFiscale = this.form.controls["codiceFiscale"].value;
				pf.nome = this.form.controls["nome"].value;
				pf.cognome = this.form.controls["cognome"].value;
				return ComponentOutputStatus.of(this.form.valid, pf);
			})
		);

		this.form.setValidators(form => {
			return (!form.get('codiceFiscale').value && 
				(!form.get('cognome').value && !form.get('nome').value)) ?
				{ requiredPF: true } : null;
		});

		this.subscription = changes$.subscribe((_) => this.done.emit(_));
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	pulisciForm() {
		const keys = Object.keys(this.form.value);
		keys.forEach(key => {
			const control: AbstractControl = this.form.get(key);
			control.setValue("");
		});
	}
}